export { default as ProductTile } from './productTile'
export { default as QuickAdd } from './quickAdd'
export { default as QuickAddSizes } from './quickAddSizes'



// WEBPACK FOOTER //
// ./src/modules/productTile/index.js